import { logger, LogContext } from '../../../helpers/logger'
import { LanguageDetectorAsyncModule } from 'i18next'
import { getDeviceLang } from '.'

export const languageDetectorPlugin: LanguageDetectorAsyncModule = {
  type: 'languageDetector',
  async: true,
  init: () => null,
  detect: async function (): Promise<string | readonly string[] | undefined> {
    try {
      //get stored language from Async storage
      const language = 'en'
      if (language) {
        //if language was stored before, use this language in the app
        return language
      } else {
        //if language was not stored yet, use device's locale
        return getDeviceLang()
      }
    } catch (error) {
      logger.warn(LogContext.I18N, 'Could not read stored language', undefined, error)
      return undefined
    }
  },
  cacheUserLanguage: async function (language: string) {
    try {
      //save a user's language choice in Async storage
    } catch {}
  },
}
